export default __webpack_public_path__ + "1.19.3/static/media/LibreDataSharecode_Arabic.210c4f6c.svg";